<button class="btn btn-bookmark rounded-0" (click)="btnClick()" [disabled]="invalid$ | async">
    <i class="now-ui-icons education_agenda-bookmark"></i>
</button>
